<template>
  <div>
    <h3>Leerlingen</h3>
    <table class="table table-condensed">
      <tbody>
        <tr>
          <th>Leerlingaantal</th>
          <td>
            {{ latestLeerlingaantal.aantal }} ({{
              latestLeerlingaantal.schooljaar
            }})
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
    leerlingaantallen: {
      required: true,
      type: Object,
    },
  },
  computed: {
    latestLeerlingaantal() {
      let latest = null;
      for (const [schooljaar, aantal] of Object.entries(this.leerlingaantallen)) {
        const entry = { schooljaar, aantal };
        if (latest === null) {
          latest = entry;
        }
        if (entry.schooljaar > latest.schooljaar) {
          latest = entry;
        }
      }

      return latest;
    },
  },
};

function isset(value) {
  return !!value;
}
</script>
